
import * as React from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

import { useTranslation } from 'react-i18next';
export const SkillForm = ({ onSubmit }) => {
    const { t } = useTranslation();
const [formData, setFormData] = React.useState({
    name: "",
    description: "",
    category: "",
    trigger: "",
    steps: "",
    priceType: "Gratis",
    price: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...formData, status: "Em Auditoria" });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-lg mx-auto p-6 bg-slate-900 rounded-lg">
      <h2 className="text-xl font-bold text-white">{t('skill_form.create_new_skill')}</h2>
      <Input placeholder={t('skill_form.skill_name_max_60_chars')} onChange={(e) => setFormData({...formData, name: e.target.value})} required />
      <Input placeholder={t('skill_form.description_1_sentence_max_160_chars')} onChange={(e) => setFormData({...formData, description: e.target.value})} required />
      <Select onValueChange={(value) => setFormData({...formData, category: value})}>
        <SelectTrigger><SelectValue placeholder={t('skill_form.category')} /></SelectTrigger>
        <SelectContent>
          <SelectItem value={t('skill_form.support')}>{t('create_skill_page.support')}</SelectItem>
          <SelectItem value={t('skill_form.legal')}>{t('create_skill_page.legal')}</SelectItem>
          <SelectItem value={t('skill_form.finance')}>{t('create_skill_page.finance')}</SelectItem>
          <SelectItem value={t('skill_form.sales')}>{t('create_skill_page.sales')}</SelectItem>
          <SelectItem value={t('skill_form.health')}>{t('create_skill_page.health')}</SelectItem>
          <SelectItem value={t('skill_form.generic')}>Generic</SelectItem>
        </SelectContent>
      </Select>
      <Input placeholder={t('skill_form.trigger_when_to_activate')} onChange={(e) => setFormData({...formData, trigger: e.target.value})} required />
      <Input placeholder={t('skill_form.steps_list_1_5')} onChange={(e) => setFormData({...formData, steps: e.target.value})} required />
      <div className="flex gap-4">
        <Select onValueChange={(value) => setFormData({...formData, priceType: value})}>
          <SelectTrigger><SelectValue placeholder={t('skill_form.price_type')} /></SelectTrigger>
          <SelectContent>
            <SelectItem value={t('skill_form.free')}>{t('skill_form.free')}</SelectItem>
            <SelectItem value={t('skill_form.paid')}>{t('skill_form.paid')}</SelectItem>
          </SelectContent>
        </Select>
        {formData.priceType === "Paid" && (
          <Input type="number" placeholder={t('skill_form.amount')} onChange={(e) => setFormData({...formData, price: e.target.value})} required />
        )}
      </div>
      <Button type="submit" className="w-full">{t('create_skill_page.submit_for_review')}</Button>
    </form>
  );
};
